import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import PromoterList from "./PromoterList";

interface Props {
  selectedPromoters: server.dto.CompanySmall[]
  onChange: (newPromoters: server.dto.CompanySmall[]) => void
}

const PromoterMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedPromoters}
    onRemove={props.onChange}
    getId={promoter => promoter.companyId}
    getLabel={promoter => <div>
      {promoter.name}
    </div>}
  >
    <PromoterList
      onItemSelected={(item) => props.onChange([...props.selectedPromoters, item])}
      excludeKeys={props.selectedPromoters.map(cc => cc.companyId)}
    />
  </MultiPickerSelectedItems>;
};

export default PromoterMultiPicker;